import React from "react";

class Calendar extends React.Component {

    state = {
        date: [
            {
                name: 'Mon',
                todey: '1',
            },
            {
                name: 'Tue',
                todey: '2',
            },
            {
                name: 'Wed',
                todey: '3',
            },
            {
                name: 'thu',
                todey: '4',
            },
            {
                name: 'Fri',
                todey: '5',
            },
        ]
    }

    render() {
        return (
            <div className="dashboard-widgets">
                <div className="dashboard-widgets" style={{ border: '1px solid #ebeaf2', background: '#fff', borderRadius: 15 }}>
                    <div style={{ borderBottom: '1px solid #ebeaf2', margin: '0 2%' }} className="d-flex justify-content-between p-3">
                        <div className="d-flex align-content-center">
                            <p>May</p>&nbsp;
                            <p>2022</p>
                        </div>
                        <div className="d-flex align-content-center">
                            <button>Next</button>&nbsp;&nbsp;
                            <button>Back</button>
                        </div>
                    </div>
                    <div className="p-3" style={{ padding: '0 5%', background: '#fff' }}>
                        <div className="d-flex" style={{ justifyContent: 'space-between' }}>
                            <button>Back</button>

                            {this.state.date.map((data, index) => {
                                return (
                                    <div key={index} className="  " style={{ alignItems: 'center', background: index == 2 ? '#5B42F3' : 'transparent', borderRadius: 10, width: '14%' }}>
                                        <div style={{ padding: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <div>
                                                <p style={{ fontSize: 15, color: index == 2 ? '#fff' : '#000' }}>{data.name}</p>
                                            </div>
                                            <div>
                                                <p style={{ color: index == 2 ? '#fff' : '#000' }}>{data.todey}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                            <button>Next</button>
                        </div>
                    </div>
                    <div style={{ borderTop: '1px solid #ebeaf2', margin: '0 2%' }} className="d-flex  p-2">
                        <div className="d-flex align-items-center">
                            <div style={{ borderRadius: 100, background: '#5B42F3', width: 8, height: 8 }} />
                            <p className="pld-2">
                                Meeting with eletive in 5 min
                            </p>
                        </div>
                    </div>
                    <div style={{ borderTop: '1px solid #ebeaf2', margin: '0 2%' }} className=" p-2">
                        <div className="d-flex align-items-center pb-3">

                            <div style={{ borderRadius: 100, background: '#5B42F3', width: 6, height: 45 }} />
                            <div className="">

                                <p className="pld-2">
                                    Product weekly . CW21
                                </p>
                                <p className="pld-2" style={{ fontSize: 12, color: '#252525' }}>
                                    03:30 - 04:30 pm
                                </p>
                            </div>

                        </div>
                        <div className=" d-flex justify-content-between align-items-center">

                            <p className="pld-2" style={{ fontSize: 13, color: '#5B42F3' }}>
                                6 Participant
                            </p>
                            <button style={{ borderRadius: 100, background: '#5B42F3', }}>
                                <p style={{ color: '#fff', padding: "8px 15px" }}>

                                    Join Room
                                </p>
                            </button>
                        </div>

                    </div>
                </div>
                {/* <div style={{ padding: 10, border: '1px solid #ebeaf2', background: '#fff', borderRadius: 15 }}>

                    <div style={{ display: 'flex', flexDirection: 'column', }}>
                        <div>

                            <p className="pld-2" style={{ color: '#5B42F3', fontWeight: 700 }}>
                                Monday
                            </p>
                        </div>
                        <div className="d-flex">

                            <p className="pld-2" style={{ color: '#252525', fontWeight: 900, fontSize: 30 }}>
                                15
                            </p>
                            <div className=" d-flex align-items-end mb-2">

                                <p className="pld-2 " style={{ color: '#5B42F3', fontWeight: 700 }}>
                                    May
                                </p>
                            </div>
                        </div>
                    </div>

                    <div style={{}} className="  p-2">
                        <div className="d-flex align-items-center">
                            <div style={{ borderRadius: 100, background: '#5B42F3', width: 8, height: 8 }} />&nbsp;
                            <p className="" style={{ fontSize: 12 }}>
                                At 03 : 00 pm
                            </p>
                        </div>
                        <div className="d-flex align-items-center">
                            <p className="" style={{ fontSize: 12 }}>
                                meeting with Eletive
                            </p>
                        </div>
                    </div>
                </div> */}
            </div>
        )
    }
}


export default Calendar;